import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AttractionBusinessDetailState {
    location: string;
    numberOfEmployees: string;
    annualRevenue: string;
    businessPurpose: string;
}


const initialState: AttractionBusinessDetailState = {
    location: '',
    numberOfEmployees: '',
    annualRevenue: '',
    businessPurpose: '',
};

const attractionBusinessDetailSlice = createSlice({
    name: 'attractionBusinessDetail',
    initialState,
    reducers: {
        setLocation(state, action: PayloadAction<string>) {
            state.location = action.payload;
        },
        setNumberOfEmployees(state, action: PayloadAction<string>) {
            state.numberOfEmployees = action.payload;
        },
        setAnnualRevenue(state, action: PayloadAction<string>) {
            state.annualRevenue = action.payload;
        },
        setBusinessPurpose(state, action: PayloadAction<string>) {
            state.businessPurpose = action.payload;
        },
        updateAttractionBusinessDetailValues(
            state,
            action: PayloadAction<Partial<AttractionBusinessDetailState>>
        ) {
            Object.assign(state, action.payload);
        },
        resetAttractionBusinessDetail() {
            const resetState = {
                location: '',
                numberOfEmployees: '',
                annualRevenue: '',
                businessPurpose: '',
            };
            return resetState;
        }
    }
});

export const {
    setLocation,
    setNumberOfEmployees,
    setAnnualRevenue,
    setBusinessPurpose,
    updateAttractionBusinessDetailValues,
    resetAttractionBusinessDetail
} = attractionBusinessDetailSlice.actions;

export default attractionBusinessDetailSlice.reducer;
